module.exports = __webpack_public_path__ + "images/card-visa.0af344670f4eb8087edf5a8c71dea75a.svg";